/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { IAbraMidiaCarouselItem, IAbraMidiaFileRaw } from '../../../interfaces/AbraMidia'
import AbraMidiaService from '../../../services/AbraMidia/AbraMidiaService'
import styles from './styles/AbraMidiaViewPage.module.css'

const imageInterval = 10000
const imageExtensions = ['jpg', 'jpeg', 'png', 'gif']

export function AbraMidiaViewPage() {
  const code = useParams().code
  const navigate = useNavigate()
  const abraMidiaService = new AbraMidiaService()
  const [abraMidiaFiles, setAbraMidiaFiles] = useState<IAbraMidiaCarouselItem[]>([])
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const videoRefs: any = useRef({})

  useEffect(() => {
    if (!code) {
      navigate('/abra-midia/visualizar')
      return
    }

    abraMidiaService
      .getByCode(code)
      .then(({ data }: { data: { files: IAbraMidiaFileRaw[] } }) => {
        setAbraMidiaFiles(
          data.files.map((file) => {
            const fileExtension = file.file_name.split('.').pop()

            return {
              ...file,
              extension: fileExtension as string,
              duration: getDuration(file.file_name)
            }
          })
        )
      })
      .catch((e: any) => {
        // eslint-disable-next-line no-console
        console.error(e)
        navigate('/abra-midia/visualizar')
      })
  }, [code])

  useEffect(() => {
    if (!abraMidiaFiles[currentIndex]) return

    if (abraMidiaFiles[currentIndex].duration > 0) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex: number) => (prevIndex + 1) % (abraMidiaFiles.length || 1))
      }, abraMidiaFiles[currentIndex].duration)

      return () => clearInterval(intervalId)
    } else if (videoRefs.current[abraMidiaFiles[currentIndex].file_path]) {
      videoRefs.current[abraMidiaFiles[currentIndex].file_path].currentTime = 0
      videoRefs.current[abraMidiaFiles[currentIndex].file_path].play()
    }
  })

  return (
    <>
      <div className={styles.carousel}>
        {abraMidiaFiles.map((file, index) => {
          return imageExtensions.includes(file.extension) ? (
            <img
              key={file.id}
              src={file.file_path}
              alt={file.file_name}
              className={`${styles.carouselImage} ${index === currentIndex ? styles.active : ''}`}
            />
          ) : (
            <video
              key={file.id}
              src={file.file_path}
              ref={(el) => (videoRefs.current[file.file_path] = el)}
              onEnded={() => setCurrentIndex((prevIndex: number) => (prevIndex + 1) % (abraMidiaFiles.length || 1))}
              muted
              className={`${styles.carouselImage} ${index === currentIndex ? styles.active : ''}`}
            />
          )
        })}
      </div>
    </>
  )
}

function getDuration(filename: string): number {
  const extension = filename.split('.').pop()

  if (imageExtensions.includes(extension as string)) {
    return imageInterval
  }

  return 0
}
